import React, {useEffect, useState} from 'react';
import {PageView} from "../GoogleAnalytics";
import LongArrowDownIcon from "@mui/icons-material/ArrowDownward";
import LongArrowUpIcon from "@mui/icons-material/ArrowUpward";
import Loader from "../Loader/Loader";
import TrainingSessionService from "../../services/trainingSession.service";
import ACAssetTrainingReview from "./ACAssetTrainingReview";

const ASC = "asc";
const DESC = "desc";

const SESSION_ID = "SESSIONID";
const START_DATE = "STARTDATE";
const END_DATE = "ENDDATE";
const FAILED = "FAILED";
const LOW_DATA = "LOWDATA";
const SUCCESSFUL = "SUCCESSFUL";

function TrainingSessionReview(props) {
    const {classes, isLoading, currentPartnerId, showAllTraining, setShowAllTraining, loggedInOrg, _isMounted, getGraphData, getLastGraphData} = props;
    const [isMounted, setIsMounted] = useState(false);
    const [trainingSessions, setTrainingSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [orgId, setOrgId] = useState(1);
    const [showBtn, setShowBtn] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const [isSelected, setIsSelected] = useState(-1);
    const [selectedSession, setSelectedSession] = useState({});
    const [columnSort, setColumnSort] = useState({ column: "", direction: ASC });

    const fetchTrainingSessions = async (partnerId) => {
        setOrgId(currentPartnerId);
        if (loggedInOrg !== "LifeWhere") {
            setShowBtn(false);
        }
        else if (showAllTraining) {
            setShowAll(true);
            setOrgId(1);
        }
        
        try {
            await TrainingSessionService.gettrainingsessions(1)
                .then(response => {
                    if (response !== null && response !== undefined) {
                        const data = response;
                        console.log("data:");
                        console.log(data);
                        console.log(response);
                        setTrainingSessions(data);
                        setLoading(false);
                    }
                })
                .catch(e => {
                    console.log(e);
                })
            PageView();
        } catch (error) {
            console.error('Error fetching training sessions:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        setIsMounted(true);
        fetchTrainingSessions(currentPartnerId).then();

        return () => {
            setIsMounted(false);
        };
    }, []);

    useEffect(() => {
        setIsSelected(-1);
        setSelectedSession({});
        fetchTrainingSessions(currentPartnerId).then();
    }, [currentPartnerId]);
    
    const onBackClick = () => {
        setIsSelected(-1);
        setSelectedSession({});
    }
    const onSessionClick = (index) => {
        if (isSelected !== index) {
            setIsSelected(index);
            setSelectedSession(trainingSessions[index]);
        }
        else {
            setIsSelected(-1);
            setSelectedSession({});
        }
    }

    const onColumnClick = (column) => {
        const newDirection = columnSort.direction === ASC ? DESC : ASC;
        setColumnSort({ column: column, direction: newDirection });
        sortTable(column);
    };

    const sortTable = (column) => {

        if (column === SESSION_ID) {
            trainingSessions.sort((a, b) =>
                columnSort.direction === ASC ? a.id - b.id : b.id - a.id
            );
        }
        else if (column === FAILED) {
            trainingSessions.sort((a, b) =>
                columnSort.direction === ASC ? a.failedTrainings?.length - b.failedTrainings?.length : b.failedTrainings?.length - a.failedTrainings?.length
            );
        }
        else if (column === LOW_DATA) {
            trainingSessions.sort((a, b) =>
                columnSort.direction === ASC ? a.notEnoughDatas?.length - b.notEnoughDatas?.length : b.notEnoughDatas?.length - a.notEnoughDatas?.length
            );
        }
        else if (column === SUCCESSFUL) {
            trainingSessions.sort((a, b) =>
                columnSort.direction === ASC ? a.traineds?.length - b.traineds?.length : b.traineds?.length - a.traineds?.length
            );
        }
        else {
            trainingSessions.sort((a, b) => {
                const dateA = column === START_DATE ? new Date(a.startDate) : new Date(a.endDate);
                const dateB = column === START_DATE ? new Date(b.startDate) : new Date(b.endDate);
                return columnSort.direction === ASC ? dateB - dateA : dateA - dateB;
            });
        }

        setTrainingSessions(trainingSessions);
    };

    let tableContent = trainingSessions?.length ?
        <tbody>
        {trainingSessions.map((session, index) =>
            <tr id={session.id} key={`${session.id}-${index}`}>
                <td onClick={() => onSessionClick(index)}
                    className={"border-left pad-left-30"}>{session.id}</td>
                <td onClick={() => onSessionClick(index)}>{session.startDate}</td>
                <td onClick={() => onSessionClick(index)}>{session.endDate}</td>
                <td onClick={() => onSessionClick(index)}>{session.failedTrainings?.length}</td>
                <td onClick={() => onSessionClick(index)}>{session.notEnoughDatas?.length}</td>
                <td className={"border-right"} onClick={() => onSessionClick(index)}>{session.traineds?.length}</td>
                
            </tr>
        )}
        </tbody>
        :
        <tbody>
        <tr>
            <td>No Sessions to Show!</td>
        </tr>
        </tbody>;

    let arrowIcon = columnSort.enabled ?
        (columnSort.reverse ?
            <LongArrowDownIcon className={"arrow-icon"}/>
            : <LongArrowUpIcon className={"arrow-icon"}/>)
        : null;

    let idIcon = columnSort.enabled && columnSort.type === SESSION_ID ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;
    let startIcon = columnSort.enabled && columnSort.type === START_DATE ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;
    let endIcon = columnSort.enabled && columnSort.type === END_DATE ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;
    let failedIcon = columnSort.enabled && columnSort.type === FAILED ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;
    let lowDataIcon = columnSort.enabled && columnSort.type === LOW_DATA ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;
    let successfulIcon = columnSort.enabled && columnSort.type === SUCCESSFUL ?
        <span className={"column-icon"}>
                {arrowIcon}
            </span>
        : null;

    let content = <div>
        <div className={"margin-20-30"}>
            <div>
                <table className="table-striped table-bordered table-sm table-hover width-100p">

                    <thead>
                    <tr className="alerts-table-row">
                        <th className={"pad-left-30"}>
                            <div onClick={() => onColumnClick(SESSION_ID)}>
                                <span className={"cursor-pointer"}>SESSION ID</span>
                                {idIcon}
                            </div>
                        </th>
                        <th>
                            <div onClick={() => onColumnClick(START_DATE)}>
                                <span className={"cursor-pointer"}>START DATE</span>
                                {startIcon}
                            </div>
                        </th>
                        <th>
                            <div onClick={() => onColumnClick(END_DATE)}>
                                <span className={"cursor-pointer"}>END DATE</span>
                                {endIcon}
                            </div>
                        </th>
                        <th>
                            <div onClick={() => onColumnClick(FAILED)}>
                                <span className={"cursor-pointer"}>FAILED TRAININGS</span>
                                {failedIcon}
                            </div>
                        </th>
                        <th>
                            <div onClick={() => onColumnClick(LOW_DATA)}>
                                <span className={"cursor-pointer"}>LOW DATA TRAININGS</span>
                                {lowDataIcon}
                            </div>
                        </th>
                        <th>
                            <div onClick={() => onColumnClick(SUCCESSFUL)}>
                                <span className={"cursor-pointer"}>SUCCESSFUL TRAININGS</span>
                                {successfulIcon}
                            </div>
                        </th>
                    </tr>
                    </thead>

                    {tableContent}

                </table>
            </div>
        </div>

    </div>;

    let contents = loading
        ? <Loader />
        :
        <div>
            {content}
        </div>;

    if (isSelected === -1) {
        return (
            <div>
                <div className='infoPage'>
                    <h3 className="pageTitle" id="tabelLabel">Summary Training Sessions Review</h3>
                    {contents}
                </div>
            </div>
        );
    }
    else {
        return (
            <ACAssetTrainingReview isSummary={true} onBackClick={onBackClick} trainingSession={selectedSession} loggedInOrg={loggedInOrg} 
                                   currentPartnerId={currentPartnerId} showAllTraining={showAllTraining} 
                                   setShowAllTraining={setShowAllTraining} getGraphData={getGraphData} 
                                   getLastGraphData={getLastGraphData}/>
        );
    }
}

export default TrainingSessionReview;